import { ActionCreatorWithPayload } from "@reduxjs/toolkit"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

export function useAction<P>(
  actionCreator: ActionCreatorWithPayload<P>,
  payload?: P,
): () => void
export function useAction<P>(
  actionCreator: ActionCreatorWithPayload<P>,
  payload: P,
): () => void {
  const dispatch = useDispatch()
  return useCallback(() => {
    dispatch(actionCreator(payload))
  }, [actionCreator, dispatch, payload])
}
